<snelstart-ui-dialog-definition [(visible)]="this.dialogVisible" id="id" size="lg" title="{{getTitle()}}">

    <snelstart-ui-dialog-header-content>
        @if (this.type !== 'TSL' && this.type !== 'JR' && this.type !== 'SB') {
            <div>
                Je ziet in het klantdossier een bevestiging van het indienen bij en van de ontvangst door de
                Belastingdienst.
            </div>
        }
        @if (this.type === 'SB') {
            <div>
                Voor de schenkbelasting geldt dat de ontvanger verplicht is om aangifte te doen en de aanslag komt ook
                altijd op
                naam van de ontvanger. Je ziet in het klantdossier een bevestiging van het indienen bij en van de
                ontvangst door
                de
                Belastingdienst.
            </div>
        }
        @if (this.type === 'JR') {
            <div>
                Je ziet in het klantdossier een bevestiging van het indienen bij en van de ontvangst door de
                Kamer van Koophandel.
            </div>
        }
        @if (this.type === 'TSL') {
            <div>
                Dien de aanvraag of wijziging toeslagen direct in bij de Belastingdienst. <br/>
                Je ziet in het klantdossier een bevestiging van het indienen bij en van de ontvangst door de
                Belastingdienst. De klant ontvangt meestal binnen 5 weken een brief van de Belastingdienst met de hoogte
                van
                de toeslag.
            </div>
        }
    </snelstart-ui-dialog-header-content>

    <snelstart-ui-dialog-body>
        @if (this.validaties !== 0) {
            <snelstart-ui-alert type="warning">
                Er zijn nog validatiemeldingen. <b></b> Klik op de button 'Validaties' in het menu en bekijk om
                welke validaties het gaat. Pas dan de gegevens aan zodat alle validatiemeldingen verdwijnen. Daarna kan
                het
                bericht verzonden worden.
            </snelstart-ui-alert>
        } @else {
            @if (this.type === 'JR') {
                <div [formGroup]="publicatieFormGroup">
                    <div formGroupName="documentResubmissionDueToTechnicalAndOrProcesRelatedInaccuracies">
                        <snelstart-ui-select-form-control [options]="optionsJaNee"
                                                          class="me-1 custom-input-250"
                                                          formControlName="value"
                                                          id="value"
                                                          label="Heraanlevering?">
                        </snelstart-ui-select-form-control>
                    </div>
                    @if (isDocumentResubmissionDueToTechnicalOrProcess) {
                        <div formGroupName="documentResubmissionDueToTechnicalAndOrProcesRelatedInaccuraciesExplanation">
                            <snelstart-ui-textarea-form-control [rows]="3"
                                                                class="me-1 custom-input-250"
                                                                formControlName="value"
                                                                id="value"
                                                                label="Reden heraanlevering">
                            </snelstart-ui-textarea-form-control>
                        </div>
                    }
                </div>
            } @else if (this.type === 'IB') {
                <div [formGroup]="submission">
                    <snelstart-ui-select-form-control (change)="onChangeSelected()"
                                                      [label]="year >= currentYear ? 'Formulier indienen van:' : 'Aangifte indienen van'"
                                                      [options]="optionsBelastingplichtige"
                                                      class="me-1 custom-input-250"
                                                      formControlName="submissionPerson"
                                                      id="submissionPerson">
                    </snelstart-ui-select-form-control>
                </div>
            } @else if (this.type === 'BTW') {
                <div [formGroup]="submission">
                    <snelstart-ui-select-form-control [options]="optionsVoorlopigDefinitief"
                                                      class="me-1 custom-input-275"
                                                      formControlName="submissionType"
                                                      id="type"
                                                      label="Type bericht">
                    </snelstart-ui-select-form-control>
                </div>
                @if (this.submission.get('submissionType')?.value !== null && this.submission.get('submissionType')?.value?.includes('aangifte')) {
                    <div [formGroup]="submission">
                        <snelstart-ui-select-form-control (change)="onChangeVatSelected()"
                                                          [options]="optionsOmzetbelasting"
                                                          class="me-1 custom-input-250"
                                                          formControlName="teVerzendenAangifteBtw"
                                                          id="teVerzendenAangifteBtw"
                                                          label="Te verzenden aangifte">
                        </snelstart-ui-select-form-control>
                    </div>
                }
                @if (this.submission.get('submissionType')?.value !== null && this.submission.get('submissionType')?.value?.includes('opgaaf')) {
                    <div [formGroup]="submission">
                        <snelstart-ui-select-form-control (change)="onChangeIcpSelected()"
                                                          [options]="optionsIcp"
                                                          class="me-1 custom-input-250"
                                                          formControlName="teVerzendenAangifteBtw"
                                                          id="teVerzendenAangifteBtw"
                                                          label="Te verzenden opgaaf">
                        </snelstart-ui-select-form-control>
                    </div>
                }
                @if (this.submission.get('submissionType')?.value !== null && this.submission.get('submissionType')?.value?.includes('suppletie')) {
                    <div [formGroup]="submission">
                        <snelstart-ui-select-form-control (change)="onChangeVatSelected()"
                                                          [options]="optionsSuppletieBtw"
                                                          class="me-1 custom-input-250"
                                                          formControlName="teVerzendenAangifteBtw"
                                                          id="teVerzendenAangifteBtw"
                                                          label="Te verzenden suppletie">
                        </snelstart-ui-select-form-control>
                    </div>
                }
            }
            @if (this.type !== 'BTW' && this.type !== 'JR' && this.type !== 'LB') {
                <div [formGroup]="submission">
                    <snelstart-ui-text-form-control [disabledControl]="true"
                                                    class="me-1 custom-input-250"
                                                    formControlName="year"
                                                    id="year"
                                                    label="Jaar">
                    </snelstart-ui-text-form-control>
                </div>
            }
            @if (this.type !== 'SB') {
                <div [formGroup]="submission">
                    <snelstart-ui-text-form-control [disabledControl]="true"
                                                    [label]="this.type === 'JR' ? 'Naam entiteit' : 'Naam belastingplichtige'"
                                                    class="me-1 custom-input-250"
                                                    formControlName="naam"
                                                    id="naam">
                    </snelstart-ui-text-form-control>
                </div>
                @if (this.type === "IB" && submission.get('submissionPerson')?.value == 1) {
                    <div [formGroup]="submission">
                        <snelstart-ui-text-form-control [disabledControl]="true"
                                                        class="me-1 custom-input-250"
                                                        formControlName="naamPartner"
                                                        id="naam"
                                                        label="Naam partner">
                        </snelstart-ui-text-form-control>
                    </div>
                }
            }
            @if (this.type === 'SB') {
                <div [formGroup]="submission">
                    <snelstart-ui-text-form-control [disabledControl]="true"
                                                    [label]="'Naam ontvanger'"
                                                    class="me-1 custom-input-250"
                                                    formControlName="naam"
                                                    id="naamSb">
                    </snelstart-ui-text-form-control>
                </div>
            }
            <div [formGroup]="submission">
                <snelstart-ui-text-form-control [disabledControl]="true"
                                                [label]="this.type === 'VPB' || this.type === 'BTW' || this.type === 'LB' ? 'Fiscaal nummer' : this.type === 'JR' ? 'KVK-nummer' : this.type === 'DB' ? 'Aangiftenummer' : 'Burgerservicenummer'"
                                                class="me-1 custom-input-250"
                                                formControlName="nummer"
                                                id="nummer">
                </snelstart-ui-text-form-control>
            </div>
            @if (this.type === "IB" && submission.get('submissionPerson')?.value == 1) {
                <div [formGroup]="submissionPartner">
                    <snelstart-ui-text-form-control [disabledControl]="true"
                                                    class="me-1 custom-input-250"
                                                    formControlName="nummer"
                                                    id="nummer"
                                                    label="Burgerservicenummer partner">
                    </snelstart-ui-text-form-control>
                </div>
            }
            @if (this.type === 'VPB' || this.type === 'JR' || this.type === 'LB') {
                <div [formGroup]="submission">
                    <snelstart-ui-date-form-control [disabledControl]="true"
                                                    [label]="this.type === 'VPB' || this.type === 'LB' ? 'Begindatum' : this.type === 'JR' ? 'Begindatum verslaglegging': 'Begindatum'"
                                                    class="me-1 custom-input-250"
                                                    formControlName="start"
                                                    id="start">
                    </snelstart-ui-date-form-control>
                    <snelstart-ui-date-form-control [disabledControl]="true"
                                                    [label]="this.type === 'VPB' || this.type === 'LB' ? 'Einddatum' : this.type === 'JR' ? 'Einddatum verslaglegging': 'Einddatum'"
                                                    class="me-1 custom-input-250"
                                                    formControlName="eind"
                                                    id="eind">
                    </snelstart-ui-date-form-control>
                </div>
            }
            @if (this.type === 'VPB') {
                <div [formGroup]="submission">
                    <snelstart-ui-select-form-control [options]="optionsVoorlopigDefinitief"
                                                      [required]="true"
                                                      class="me-1 custom-input-275"
                                                      formControlName="submissionType"
                                                      id="submissionType"
                                                      label="Type bericht">
                    </snelstart-ui-select-form-control>
                </div>
            }
            @if (this.type !== 'TSL' && this.type !== 'BTW' && this.type !== 'JR' && this.type !== 'DB' && this.type !== 'SB') {
                <div [formGroup]="submission">
                    <snelstart-ui-number-form-control [disabledControl]="true"
                                                      [showAllDecimals]="false"
                                                      align="right"
                                                      class="me-1 custom-input-250"
                                                      formControlName="bedrag"
                                                      id="bedrag"
                                                      label="Te ontvangen / betalen"
                                                      prefix="€">
                    </snelstart-ui-number-form-control>
                </div>
            }
            @if (this.type === 'SB') {
                <div [formGroup]="submission">
                    <snelstart-ui-number-form-control [disabledControl]="true"
                                                      [showAllDecimals]="false"
                                                      align="right"
                                                      class="me-1 custom-input-250"
                                                      formControlName="bedrag"
                                                      id="bedragSb"
                                                      label="Te betalen"
                                                      prefix="€">
                    </snelstart-ui-number-form-control>
                </div>
            }
            @if (this.type === 'DB') {
                <div [formGroup]="submission" class="pb-2">
                    <snelstart-ui-number-form-control [disabledControl]="true"
                                                      [showAllDecimals]="false"
                                                      align="right"
                                                      class="me-1 custom-input-250"
                                                      formControlName="bedrag"
                                                      id="bedragDb"
                                                      label="Te betalen"
                                                      prefix="€">
                    </snelstart-ui-number-form-control>
                </div>
                <snelstart-ui-alert type="warning">
                    Maak het bedrag ad
                    € {{ this.submission.get('bedrag')?.value | number: '1.0-0' }} over op rekeningnummer
                    <b>NL04 RABO 0200 1818 90 t.n.v. Belastingdienst</b>.<br/>
                    Vermeld bij de betaling de omschrijving
                    <b>"Aangiftenummer {{ this.submission.get('nummer')?.value }}</b>".<br/>
                    Je vindt deze informatie ook op het pdf-rapport van de aangifte.
                </snelstart-ui-alert>
            }
            @if (this.submission.get('teVerzendenAangifteBtw')?.value !== null &&
            this.submission.get('submissionType')?.value !== null &&
            !this.submission.get('submissionType')?.value?.includes('suppletie') &&
            !this.submission.get('submissionType')?.value?.includes('opgaaf')) {
                <div [formGroup]="submission">
                    <snelstart-ui-number-form-control [disabledControl]="true"
                                                      [showAllDecimals]="false"
                                                      align="right"
                                                      class="me-1 custom-input-250"
                                                      formControlName="bedrag"
                                                      id="bedragBtw"
                                                      label="Te ontvangen / betalen"
                                                      prefix="€">
                    </snelstart-ui-number-form-control>
                </div>
            }
            @if (this.type === 'TSL') {
                <div [formGroup]="this.toeslagenFormGroup">
                    <snelstart-ui-select-form-control (change)="this.saveAllowanceForm()"
                                                      [options]="optionsToeslagen"
                                                      class="me-1 custom-input-250"
                                                      formControlName="actie"
                                                      id="optionsToeslagen"
                                                      label="Type wijziging">
                    </snelstart-ui-select-form-control>

                    <snelstart-ui-date-form-control (change)="this.saveAllowanceForm()"
                                                    class="me-1 custom-input-250"
                                                    formControlName="ingangsdatumWijziging"
                                                    id="ingangsdatumWijziging"
                                                    label="Ingangsdatum wijziging">
                    </snelstart-ui-date-form-control>
                    @if (showIngangsdatumMismatchKot) {
                      <snelstart-ui-alert type="warning">
                        Geen juiste datum: de ingangsdatum moet gelijk zijn aan een 'datum start opvang' van een kind.
                      </snelstart-ui-alert>
                    }
                    @if (showIngangsdatumMismatchHuur) {
                      <snelstart-ui-alert type="warning">
                        Geen juiste datum: de ingangsdatum moet gelijk zijn aan een startdatum bewoning van een huurwoning.
                      </snelstart-ui-alert>
                    }
                </div>
            }
        }
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
        <snelstart-ui-button (click)="this.dialogVisibleChange.emit(false)" btn-x class="me-1" id="cancel"
                             type="secondary">Annuleren
        </snelstart-ui-button>
        <snelstart-ui-button [config]="indienenButtonConfig"
                             [disabled]="!isOptionSelected() || showIngangsdatumMismatchKot || showIngangsdatumMismatchHuur || validaties > 0"
                             icon="check"
                             id="save"
                             type="primary">Nu indienen
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
